import React from 'react';
import { Card } from 'semantic-ui-react';

import './index.css';

const SectionCard = ({ title, date, description }) => (
  <Card className="section-card hvr-pulse-shrink" href={title.replace(/ /g, '_')}>
    <Card.Header className="section-card-header">
      {title}
    </Card.Header>
    <Card.Content className="section-card-content">
      <h3 className="description">{description}</h3>
      <h4 className="date-text">{date}</h4>
    </Card.Content>
  </Card>
);

export default SectionCard;



// WEBPACK FOOTER //
// ./src/modules/SectionCard/component.js